<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원팝업</span>
            <span class="txt">센터의 다양한 정보와 소식을 앱으로 빠르게 전달 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!popupDetail"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/setting/member/pop/list">목록</router-link>
                    <router-link v-if="isWriteAuth" :to="`/madmin/setting/member/pop/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="isWriteAuth" class="com-btn red" @click="onClickDeletePopup(popupDetail.id)">
                        삭제
                    </button>
                </div>
            </div>
            <table class="com-table view">
                <colgroup>
                    <col style="width: 170px" />
                    <col style="width: auto" />
                    <col style="width: 170px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td>{{ popupDetail.boardCategory === null ? '' : popupDetail.boardCategory.name }}</td>
                        <th>글쓴이</th>
                        <td>{{ popupDetail.info.createdName }}</td>
                    </tr>
                    <tr>
                        <th>조회수</th>
                        <td>{{ popupDetail.viewCount }}</td>
                        <th>등록일</th>
                        <td>{{ popupDetail.info.createdAt | timestampFilter }}</td>
                    </tr>
                    <tr>
                        <th>첨부파일</th>
                        <td colspan="3">
                            <a v-for="file in fileList" :href="file.fileUrl" class="file-down" style="cursor: pointer">
                                {{ file.name }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td colspan="3">{{ popupDetail.title }}</td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div class="ck-content" v-html="popupDetail.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/setting/member/pop/list">목록</router-link>
                    <router-link v-if="isWriteAuth" :to="`/madmin/setting/member/pop/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="isWriteAuth" class="com-btn red" @click="onClickDeletePopup(popupDetail.id)">
                        삭제
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingMemberPopDetail',
    components: { LoadingSpinner },
    props: {},
    computed: {
        isWriteAuth() {
            const { getters } = this.$store;
            return (
                getters['auth/isCareAdmin'] ||
                getters['auth/isSystemAdmin'] ||
                getters['auth/isCenterAdmin'] ||
                getters['auth/isCenterStaff']
            );
        },
        isReadAuth() {
            const { getters } = this.$store;
            return this.isWriteAuth || getters['auth/isCustomer'];
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    mounted() {
        this.fetchPopupDetail();
    },
    data() {
        return {
            isLoading: false,
            id: this.$route.params.id,
            popupDetail: null,
            fileList: null,
        };
    },
    methods: {
        // 팝업 상세 Fetch
        async fetchPopupDetail() {
            try {
                const { data } = await this.sendGetPopupDetail(this.id);
                this.popupDetail = data;
                console.log(data);
                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.sendGetPopupDetailFileGroup(data.fileGroupId);
                    this.fileList = fileGroupData.data;
                }

                console.log('===> Success Loading Center Popup Detail', data);
            } catch (error) {
                console.log(error);
            }
        },

        // 팝업 삭제
        async onClickDeletePopup(id) {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetDeletePopup(id);
                alert('팝업을 삭제했습니다.');
                this.isLoading = false;
                console.log('===> Success Center Popup Delete', data);
                this.$router.push({ name: 'SettingMemberPopList' });
            } catch (error) {
                console.log(error);
            }
        },

        // 팝업 상세 API
        sendGetPopupDetail(id) {
            return api.get(`/admin/api/board/popup/${id}/view`);
        },

        // 팝업 상세 첨부 파일 리스트 API
        sendGetPopupDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 팝업 삭제 API
        sendGetDeletePopup(id) {
            return api.delete(`/admin/api/board/popup/${id}`);
        },
    },
};
</script>
<style lang="scss"></style>
